<arm-layout menuTitle="Thresholds">

  <div menu-header class="threshold-header">

    <arm-action-bar (addClick)="addThreshold()" [disableAdd]="!(showAddIcon() && isAuthorized)" [addTooltip]="'Add threshold'"
                    (deleteClick)="deleteThreshold()" [disableDelete]="!(this.selectedThreshold && isAuthorized)" [deleteTooltip]="'Delete threshold'"
                    (refreshClick)="refreshThreshold()" [refreshTooltip]="'Refresh'" >
    </arm-action-bar>
  </div>

    <div menu>
        <thresholds-list (onSelection)="onThresholdSelection($event)"></thresholds-list>
    </div>
    <div main>
        <thresholds-configuration [selectedThreshold]="selectedThreshold"
                                  (onChange)="onThresholdChange($event)">
        </thresholds-configuration>
    </div>
</arm-layout>
